// TODO: TS: check ts

import { isInteger } from "lodash";

import { DEFAULT_LANGUAGE } from "../enums/language";
import { isNumericGuard } from "./dataManipulation";

export const valueOrAlternative = <T>(value: null | T | undefined, alt: string | T = "---"): string | T => {
  if (value == null) return alt;
  if (isNumericGuard(value)) return value;

  const valueString = String(value);
  return valueString ? valueString : alt;
};

export const replaceDecimalPointWithCommaOld = (number: null | number | string | undefined): null | string => {
  if (!number) return null;
  const str = number.toString();
  return str.replace(".", ",");
};

export const replaceDecimalPointWithComma = (number: any): any => {
  if (!number) return "";
  return number;
};

export const formatNumberToLocale = (number: any, locale: string, noOfDigigts = 2): any => {
  if (number === null || number === undefined || typeof number !== "number") return number;
  const isIntegerNumber = isInteger(number);
  const floatConf = {
    maximumFractionDigits: noOfDigigts,
    minimumFractionDigits: noOfDigigts,
  };
  return number?.toLocaleString(locale, !isIntegerNumber ? floatConf : undefined);
};

export const addCommaToNumber = (number: any, noOfDigigts?: number): any => {
  return formatNumberToLocale(number, "en-US", noOfDigigts);
};

export const formatNumberToGerman = (number: any, noOfDigigts?: number): any => {
  return formatNumberToLocale(number, "de-DE", noOfDigigts);
};

export const formatNumberBasedOnUser = (number: any, noOfDigigts?: number): any => {
  const userLanguage = localStorage.getItem("language") ?? DEFAULT_LANGUAGE;
  if (userLanguage === "de") return formatNumberToGerman(number, noOfDigigts);
  return addCommaToNumber(number, noOfDigigts);
};

export const parseLocaleStringBasedOnUser = (stringNumber: any): any => {
  if (stringNumber === null || stringNumber === undefined) return stringNumber;
  if (typeof stringNumber === "number") return stringNumber;
  if (typeof stringNumber === "boolean") return stringNumber;
  if (typeof stringNumber === "object") return stringNumber;

  const userLanguage = localStorage.getItem("language") ?? DEFAULT_LANGUAGE;
  const example = Intl.NumberFormat(userLanguage).format(12345.6);
  const group = example.match(/(\D+)/g)?.[0]?.trim() || ",";
  const decimal = example.match(/(\D+)/g)?.[1]?.trim() || ".";

  const normalized = stringNumber.replace(new RegExp(`\\${group}`, "g"), "").replace(new RegExp(`\\${decimal}`), ".");

  const isBoolean = normalized === "true" || normalized === "false";
  if (isBoolean) return normalized === "true";

  const parsed = parseFloat(normalized);
  return isNaN(parsed) ? stringNumber : parsed;
};

export const sentenceCase = (string: null | string | undefined): null | string => {
  if (!string) return null;
  return string == null ? null : string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
};

export const capitalizeFirstLetter = (string: null | string | undefined): null | string => {
  if (!string) return null;
  return string == null ? null : String(string).charAt(0).toUpperCase() + String(string).slice(1);
};
